<template>
  <div class="modal-body-content">
    <div class="modal-body-list-box">
      <div class="search-box-in-title">
        <h2>{{ $t('system_log') }} {{ $t('list') }}</h2>
      </div>
      <div style="display: flex; width: 100%; padding: 0 48px;" :style="getIsMobile() ? { padding: '0 5px' } : {}">
        <div style="display: flex; gap: 10px; width: 100%;" :style="getIsMobile() ? { gap: '3px', overflowX: 'auto', flexDirection: 'column' } : {}">
          <div style="display: flex; gap: 10px; align-items: center;" :style="getIsMobile() ? { width: '100%', justifyContent: 'space-between' } : {}">
            <input
            id="startFilter"
            type="datetime-local"
            v-model="startDate"
            :max="endDate"
            style="width: 230px;"
            :style="getIsMobile() ? { fontSize: '11px', width: '160px' } : {}"
            />
            ~
            <input
            id="endFilter"
            type="datetime-local"
            v-model="endDate"
            :min="startDate"
            :max="ConvertDateTimeString(now, 'YYYY-MM-DDTHH:MM')"
            style="width: 230px;"
            :style="getIsMobile() ? { fontSize: '11px', width: '160px' } : {}"
            />
          </div>
          <input v-model="search" :placeholder="$t('insert_search_query')"  style="flex: 1; min-width: 200px; max-width: 320px;" :style="getIsMobile() ? { fontSize: '11px', width: '160px' } : {}" />
          <!-- <div style="display: flex; gap -->
        </div>
        <div class="button-group" style="width: 139px; min-width: 116px;" v-show="!getIsMobile()">
          <button class="white-button" @click.stop="exportToExcel_SL(filteredLogs, startDate, endDate)" style="display: flex; gap: 5px;">
            {{ $t('excel_download') }}
            <img src="@/assets/images/download_blue.svg"/>
          </button>
        </div>
      </div>

      <div style="display: flex; flex-direction: column; gap: 24px; align-items: center; width: 100%;" :style="getIsMobile() ? { width: '100%' } : {}">
        <table style="">
          <thead>
            <tr>
              <th class="w20p" @click="toggleSort('system_log', 'occurred_at')">
                {{ $t('time') }}
                <span v-if="sortStates.system_log.find(col => col.id === 'occurred_at').order">
                  <img v-if="sortStates.system_log.find(col => col.id === 'occurred_at').order === 1" src="@/assets/images/sort_up.svg" style="width: 20px;" />
                  <img v-else src="@/assets/images/sort_down.svg" style="width: 20px;" />
                </span>
                <span v-else><img src="@/assets/images/sort_none.svg" style="padding: 0;"/></span>
              </th>
              <th v-show="!getIsMobile()" class="w10p" @click="toggleSort('system_log', 'type')">
                {{ $t('type') }}
                <span v-if="sortStates.system_log.find(col => col.id === 'type').order">
                  <img v-if="sortStates.system_log.find(col => col.id === 'type').order === 1" src="@/assets/images/sort_up.svg" style="width: 20px;" />
                  <img v-else src="@/assets/images/sort_down.svg" style="width: 20px;" />
                </span>
                <span v-else><img src="@/assets/images/sort_none.svg" style="padding: 0;"/></span>
              </th>
              <th class="w35p" @click="toggleSort('system_log', 'message')">
                {{ $t('message') }}
                <span v-if="sortStates.system_log.find(col => col.id === 'message').order">
                  <img v-if="sortStates.system_log.find(col => col.id === 'message').order === 1" src="@/assets/images/sort_up.svg" style="width: 20px;" />
                  <img v-else src="@/assets/images/sort_down.svg" style="width: 20px;" />
                </span>
                <span v-else><img src="@/assets/images/sort_none.svg" style="padding: 0;"/></span>
              </th>
              <th v-show="!getIsMobile()" class="w35p" @click="toggleSort('system_log', 'description')">
                {{ $t('description') }}
                <span v-if="sortStates.system_log.find(col => col.id === 'description').order">
                  <img v-if="sortStates.system_log.find(col => col.id === 'description').order === 1" src="@/assets/images/sort_up.svg" style="width: 20px;" />
                  <img v-else src="@/assets/images/sort_down.svg" style="width: 20px;" />
                </span>
                <span v-else><img src="@/assets/images/sort_none.svg" style="padding: 0;"/></span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="log in paginatedData" :key="log.time" :style="{ backgroundColor: getRowColor(log.type) }" @click="openSmallModal(log)">
              <td class="w20p">{{ log.occurred_at }}</td>
              <td v-show="!getIsMobile()" class="w10p"><strong>{{ log.type }}</strong></td>
              <td class="w35p" :title="log.message" style="text-align: left; padding-left: 5px;">{{ log.message }}</td>
              <td v-show="!getIsMobile()" class="w35p" :title="log.description" style="text-align: left; padding-left: 5px;">{{ log.description }}</td>
            </tr>
          </tbody>
        </table>
        <!-- 페이지네이션 -->
        <div class="pagination-control" style="padding: 0;">
          <div>
            <img src="@/assets/images/double_arrow_left_gray.svg" @click.stop="prevPagePer" v-show="currentPage !== 1"/>
            <img src="@/assets/images/arrow_left_gray.svg" @click.stop="prevPage" v-show="currentPage !== 1"/>
          </div>
          <span v-for="page in currentPageRange" :key="page" @click.stop="currentPage = page" :class="{ selected: currentPage === page }">{{ page }}</span>
          <div>
            <img src="@/assets/images/arrow_right_gray.svg" @click.stop="nextPage" v-show="(currentPage !== totalPages) && totalPages !== 0"/>
            <img src="@/assets/images/double_arrow_right_gray.svg" @click.stop="nextPagePer" v-show="(currentPage !== totalPages) && totalPages !== 0"/>
          </div>
        </div>
      </div>
    </div>

    <!-- #region 로그 개별 확인 모달 -->
    <div v-if="showSmallModal" class="modal-body-content-modal-background">
      <div class="modal-body-content-modal">
        <div class="modal-body-edit-box">
          <div class="modal-body-edit-box-title">
            <h2>{{ $t('system_log') }}</h2>
            <img src="@/assets/images/x_black.svg" @click="closeSmallModal()"/>
          </div>
          <div class="modal-body-edit-box-content">
            <div class="modal-body-edit-box-content-main">
              <table>
                <tbody>
                  <tr>
                    <th>{{ $t('time') }}</th>
                    <td>{{ nowSelectedLog.occurred_at }}</td>
                  </tr>
                  <tr>
                    <th>{{ $t('type') }}</th>
                    <td>{{ nowSelectedLog.type }}</td>
                  </tr>
                  <tr style="height: fit-content;">
                    <th style="height: 100%;">{{ $t('message') }}</th>
                    <td :title="nowSelectedLog.message" style="height: fit-content; white-space: unset; text-align: left;">{{ nowSelectedLog.message }}</td>
                  </tr>
                  <tr style="height: fit-content;">
                    <th style="height: 100%;">{{ $t('description') }}</th>
                    <td :title="nowSelectedLog.description" style="height: fit-content; white-space: unset; text-align: left;">{{ nowSelectedLog.description }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- #endregion -->
  </div>
</template>


<script setup>
import { exportToExcel_SL } from '@/utils/ExcelExport';
import { ConvertDateTimeString, getIsMobile } from '@/utils/GlobalUtility';
import { loadingStore } from '@/utils/LoadingStore';
import { showSmallModal } from '@/utils/ModalUtility';
import { GET_SERVER_REQUEST, log_list } from '@/utils/ServerConnect';
import { sortedSLList, sortStates, toggleSort } from '@/utils/SortUtility';
import { ref, computed, onMounted, watch } from 'vue';

const nowSelectedLog = ref(null);

// const selectedCategory = ref('');
// const selectedAlertLevel = ref(''); // 새로운 필터 상태 변수
const now = new Date();
const startDate = ref(ConvertDateTimeString(new Date(now.getTime() - 24 * 60 * 60 * 1000), 'YYYY-MM-DDTHH:MM'));
const endDate = ref(ConvertDateTimeString(new Date(now.getTime() + 60 * 1000), 'YYYY-MM-DDTHH:MM'));

// const categories = [
//   { label: '유형 전체', value: '' },
//   { label: 'App', value: 'A' },
//   { label: 'Server', value: 'B' },
//   { label: 'Web', value: 'C' }
// ];

// ✅ 배경색 결정 함수
const getRowColor = type => {
  const lastTwoDigits = type.slice(-2);
  if (lastTwoDigits === '00') return '#ffcccc'; // 빨간색
  if (lastTwoDigits === '01') return '#cce5ff'; // 파란색
  return '#fff3cd'; // 노란색 (기본)
};

// 선택된 데이터만 JSON으로 생성
const createParam = () => {
  let data = '/?';

  if (startDate.value) {
    data += 'starttime=' + startDate.value.replaceAll(':', '').replaceAll('-', '').replaceAll('T', '') + '&';
  }

  if (endDate.value) {
    data += 'endtime=' + endDate.value.replaceAll(':', '').replaceAll('-', '').replaceAll('T', '') + '&';
  }

  // if (selectedEventType.value !== '') {
  //   data += 'type=' + getEvnetKeyByValue(selectedEventType.value) + '&';
  // }
  return data;
};

const fetchLogs = async () => {
  loadingStore.showLoading();
  try {
    log_list.value = await GET_SERVER_REQUEST("log", createParam());
  } catch (error) {
    console.error(error);
  }
  loadingStore.hideLoading();
};

onMounted(async () => {
  await fetchLogs();
  loadingStore.hideLoading();
});
watch([startDate, endDate], fetchLogs);

const currentPage = ref(1);
const itemsPerPage = computed(() => { return 10 });
const showOncePage = computed(() => { return (getIsMobile() ? 5 : 10) });
// 페이지네이션된 데이터 계산
const totalPages = computed(() =>
  Math.ceil(filteredLogs.value.length / itemsPerPage.value)
);
const paginatedData = computed(() => {
  const start = (currentPage.value - 1) * itemsPerPage.value;
  return filteredLogs.value.slice(start, start + itemsPerPage.value);
});
const minPageRange = computed(() => {
  if (currentPage.value % showOncePage.value === 0) return currentPage.value - (showOncePage.value - 1);
  else return currentPage.value - ((currentPage.value % showOncePage.value) - 1);
});
const maxPageRange = computed(() => {
  let num = minPageRange.value + (showOncePage.value - 1);
  if (num > totalPages.value) num = totalPages.value
  return num;
});
const currentPageRange = computed(() => {
  const range = []
  for (let i = minPageRange.value; i <= maxPageRange.value; i++) {
    range.push(i)
  }
  return range;
});
// 페이지네이션 함수
const prevPage = () => {
  if (currentPage.value > 1) currentPage.value--;
};
const prevPagePer = () => {
  const num = Math.floor(currentPage.value / showOncePage.value);
  if (num < 1) currentPage.value = 1;
  else currentPage.value = ((num - 1) * showOncePage.value) + 1;
};
const nextPage = () => {
  if (currentPage.value < totalPages.value) currentPage.value++;
};
const nextPagePer = () => {
  const num = Math.floor(currentPage.value / showOncePage.value);
  const check = ((num + 1) * showOncePage.value) + 1
  if (check > totalPages.value) currentPage.value = totalPages.value;
  else currentPage.value = check;
};

// 검색어에 따라 필터링된 목록을 반환
const search = ref("");
const filteredLogs = computed(() => {
  const query = search.value.trim().toLowerCase(); // 공백 제거 & 소문자 변환

  return sortedSLList.value.filter(sl =>
  String(sl.occurred_at)?.toLowerCase().includes(query) // ID로 검색
    || String(sl.type)?.toLowerCase().includes(query) // 이름으로 검색
    || String(sl.message)?.toLowerCase().includes(query) // 영역으로 검색
    || String(sl.description)?.toLowerCase().includes(query) // 진입/진출으로 검색
  );
});
watch(search, () => {
  if (currentPage.value > totalPages.value) currentPage.value = totalPages.value;
  if (currentPage.value === 0) currentPage.value = 1;
});

const openSmallModal = (log) => {
  nowSelectedLog.value = log;
  showSmallModal.value = true;
};
const closeSmallModal = () => {
  showSmallModal.value = false;
  nowSelectedLog.value = null;
};
</script>